import { useCallback } from 'react'
import { useSetRecoilState } from 'recoil'
import { useTranslation } from 'react-i18next'
import { pageLoadingAtom } from '@/atoms/editorAtoms'
import { useErrorHandler } from '@/hooks/utility/useErrorHandler'
import { ERROR_CODE } from '@messenger/consts'
import { validateCaseImageFile, extractErrorMessage } from '@messenger/utils'

export const useFileUpload = ({ uploadFunction, setImages }) => {
  const { t } = useTranslation()
  const handleError = useErrorHandler('useFileUpload')
  const setPageLoading = useSetRecoilState(pageLoadingAtom)

  const handleFileChange = useCallback(
    async (e) => {
      try {
        const { files } = e?.target || {}
        if (files && files.length) {
          const file = files[0]

          const validation = validateCaseImageFile(file)
          if (!validation.valid) {
            const msg =
              validation.error.code === ERROR_CODE.FILE_TOO_LARGE
                ? t('toast.fileTooLarge', validation.error.data)
                : t('toast.unsupportedImageFormat')
            handleError(msg)
            return
          }
          const validFile = validation.sanitizedFile

          const fd = new FormData()
          fd.append('file', validFile, validFile.name)

          const resp = await uploadFunction(fd)
          setImages(resp.data)
        }
      } catch (error) {
        const { message, code } = extractErrorMessage(error)
        if (code === ERROR_CODE.UNSUPPORTED_IMAGE_FORMAT) {
          handleError(t('toast.unsupportedImageFormat'), error)
        } else {
          handleError(message, error)
        }
        setPageLoading(false)
      }
    },
    [uploadFunction, setImages, handleError, setPageLoading, t],
  )

  return handleFileChange
}

export default useFileUpload
